(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4455],{

/***/ 459:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcast/[playlists]",
      function () {
        return __webpack_require__(503);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ PodcastPlaylist; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Home_FeaturedLastNews__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2826);
/* harmony import */ var _components_Layout_ItemListLastNews_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2747);
/* harmony import */ var _components_Layout_Podcast__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9211);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7590);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_7__);








var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_7___default()().publicRuntimeConfig;
var __N_SSP = true;
function PodcastPlaylist(param) {
    var homeData = param.homeData, navBarData = param.navBarData, tagsData = param.tagsData, segmentacoes = param.segmentacoes, timelineData = param.timelineData, breadcrumbData = param.breadcrumbData, _schema = param.schema, schema = _schema === void 0 ? null : _schema;
    var AdsTypeGenerators = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return __webpack_require__.e(/* import() */ 8463).then(__webpack_require__.bind(__webpack_require__, 2444));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(2444)
                ];
            }
        },
        ssr: false
    });
    var RSSButtonNoSSR = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return __webpack_require__.e(/* import() */ 6086).then(__webpack_require__.bind(__webpack_require__, 8172));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(8172)
                ];
            }
        },
        ssr: false
    });
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var playlists = router.query.playlists;
    var title = "Mais Recentes";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        layoutData: {
            segmentacoes: segmentacoes,
            tagsData: tagsData,
            navBarData: navBarData,
            schema: schema,
            breadcrumbList: breadcrumbData
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Podcast__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                podcastData: homeData,
                breadcrumbs: breadcrumbData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_ItemListLastNews_styles__WEBPACK_IMPORTED_MODULE_3__/* .AdContainer */ .g1, {
                noPadding: true,
                billboard: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AdsTypeGenerators, {
                    type: "billboard/main/listing"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Home_FeaturedLastNews__WEBPACK_IMPORTED_MODULE_2__["default"], {
                featuredLastNewsData: timelineData.timeline,
                rootPage: "podcast/".concat(playlists),
                textTitle: title,
                headingTag: "h1",
                route: "podcast/".concat(playlists),
                routeType: "tipo"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RSSButtonNoSSR, {
                link: "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL, "/rss/podcast/").concat(playlists, "/")
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [162,1216,8912,5730,8802,7590,944,2826,2250,9774,2888,179], function() { return __webpack_exec__(459); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);